
import Vue, { PropType } from 'vue';
import Api from '@/core/api';
import { get } from 'lodash';
import Viewer from './Viewer.vue';

export default Vue.extend({
    name: 'Viewers',

    components: {
        Viewer
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        config: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        isWebinar: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        viewers() {
            return get(this, 'config.viewers', []);
        },

        hidden() {
            return get(this, 'config.hidden');
        }
    }
});
